<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
@if (!isLoading) {
  <div class="ziro-content">
    <div class="mx-4 flex-grow-1">
      @if (pageDisabled) {
        <div
          class="offset-md-1 col-md-10 ziro-page-alert alert border-warning"
          data-automation="ziro-page-disabled-alert"
        >
          <i class="{{ ziroIcons.WARNING_TRIANGLE }} text-warning fa-4x"></i>
          <div class="ms-3" [innerHTML]="'tkey;userdetail.home.services.disabled_service.label' | escapeHtml"></div>
        </div>
      }
      @if (!pageDisabled) {
        <ziro-pcce-agent-settings-form
          [entity]="pcceAgent"
          [pcceAgentRef]="pcceAgentRef"
          [pcceServer]="pcceServer"
          [isNewAgent]="isNewAgent"
          [isSsoAgent]="isSsoAgent"
          [fieldConfig]="fieldConfig"
        ></ziro-pcce-agent-settings-form>
      }
    </div>
  </div>
}
